/**
 * SportApiSync - Component that synchronizes SportContext with API client
 * Ensures API requests automatically use the current sport context
 */

import { useEffect } from 'react';
import { useSport } from '../contexts/SportContext';
import unifiedApi from '../services/unifiedApiClient';

export const SportApiSync: React.FC = () => {
  const { currentSport } = useSport();

  useEffect(() => {
    if (!currentSport) return;

    // Update API client whenever sport changes
    unifiedApi.setSport(currentSport.id);

    // Log the sport change
    console.log(`🎯 API client sport context updated to: ${currentSport.name} (${currentSport.id})`);
  }, [currentSport]);

  // This component doesn't render anything
  return null;
};